// extracted by mini-css-extract-plugin
module.exports = {"RoundedCta":"styles_RoundedCta__frnpY","primary":"styles_primary__1mZ8s","secondary":"styles_secondary__1Nf4l","tertiary":"styles_tertiary__1J2Ch","small":"styles_small__2DTiP"};